import { Pagination } from '@packages/toolbox/dist/declarations/pagination';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { StatusResponse } from 'SharedDir/declarations/endpoint';
import { Integrations } from 'SharedDir/declarations/integrations';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';

export default class ActualizationConfigApiClass extends SimpleApi<
  Integrations.ActualizationConfigFull,
  Integrations.ActualizationConfig
> {
  constructor() {
    super(`${SERVER_API}/integrations/persons/actualizations/configs`);
  }

  async getTasks<T extends object = object>(params: Partial<PaginationParams<T>>) {
    const url = `${this.url}/tasks`;
    const { data } = (await http({ method: 'GET', url, params })) as AxiosResponse<
      Paginated<Integrations.ActualizationTaskFull, T>
    >;
    return data;
  }

  async startTask(configId: number) {
    const url = `${this.url}/${configId}/start`;
    const { data } = (await http({
      method: 'POST',
      url,
    })) as AxiosResponse<Integrations.ActualizationTaskFull>;
    return data;
  }

  async stopTask(taskId: number) {
    const url = `${this.url}/tasks/${taskId}/stop`;
    const { data } = (await http({
      method: 'POST',
      url,
    })) as AxiosResponse<Integrations.ActualizationTaskFull>;
    return data;
  }
}
